/* eslint-disable class-methods-use-this */
var ezdia;
(function (ezdia) {
    var ROW_LOADING_CLS = 'ui-widget-content__loading';
    var COL_LOADING_CLS = 'editable-column__loading';
    var QUERY_PARAMS_NAMES = {
        DR: 'dateRange',
        FD: 'fromDate',
        TD: 'toDate',
        CFD: 'compareFromDate',
        CTD: 'compareToDate'
    };
    function updateList(colModel, event) {
        var currentTarget = event.currentTarget;
        var $element = $(currentTarget);
        var value = currentTarget.value;
        var trrow = $element.closest('tr').addClass(ROW_LOADING_CLS);
        var tdcol = $element.closest('td').addClass(COL_LOADING_CLS);
        var rowId = colModel.rowId, name = colModel.name;
        var pageParams = $.ezdia.config.pageParams;
        var formType = pageParams.formType;
        var data = "id=" + rowId + "&list=" + value + "&formtype=" + formType;
        data += "&channel=" + pageParams.channel;
        if (!value) {
            data += "&" + name + "_delete=true";
        }
        $.ajax({
            type: 'POST',
            url: 'EditStoreForm.htm',
            data: data,
            dataType: 'text',
            success: function (resp) {
                tdcol.removeClass(COL_LOADING_CLS);
                trrow.removeClass(ROW_LOADING_CLS);
                var response = ezdia.util.jsonParse(resp) || {};
                if (response.success) {
                    ezdia.util.showSuccessError({
                        message: response.msg || 'Error updating data'
                    });
                    $element.parents('td').find('textarea').val(value);
                }
                else {
                    ezdia.util.showSuccessError({
                        message: response.msg || 'Error updating data',
                        error: true
                    });
                }
            },
            error: function (response) {
                trrow.removeClass(ROW_LOADING_CLS);
                ezdia.util.showSuccessError({
                    message: response.msg || 'Error updating data',
                    error: true
                });
            }
        });
    }
    var EzAnalytics = /** @class */ (function () {
        function EzAnalytics() {
        }
        EzAnalytics.prototype.render = function () {
            this.init();
            this.search();
            this.grid();
            this.quickAction();
            this.actions();
            pageLoadingDone();
        };
        EzAnalytics.prototype.export = function (actiontype) {
            var e_1, _a;
            var quickactionObj = $.ezdia.config.pageParams.quickactionObj;
            var qaObj;
            try {
                for (var quickactionObj_1 = __values(quickactionObj), quickactionObj_1_1 = quickactionObj_1.next(); !quickactionObj_1_1.done; quickactionObj_1_1 = quickactionObj_1.next()) {
                    var quickaction = quickactionObj_1_1.value;
                    var name_1 = quickaction.name;
                    if (name_1 === actiontype) {
                        qaObj = quickaction;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (quickactionObj_1_1 && !quickactionObj_1_1.done && (_a = quickactionObj_1.return)) _a.call(quickactionObj_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.handelExportAction(qaObj);
        };
        EzAnalytics.prototype.handelExportAction = function (qaObj) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, formtype, channel, dateRange, name, btnlabel, actionUrl, data, ids, _b, fromDate, toDate, compareFromDate, compareToDate, response, ex_1;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = $.ezdia.config
                                .pageParams, formtype = _a.formType, channel = _a.channel, dateRange = _a.dateRange;
                            name = qaObj.name, btnlabel = qaObj.btnlabel, actionUrl = qaObj.actionUrl;
                            data = {
                                channel: channel,
                                formtype: formtype,
                                btnlabel: btnlabel,
                                quickActionName: name,
                                date_range: dateRange
                            };
                            ids = ezdia.util.getSelectedGridItemsIds();
                            if (ids.length) {
                                data.ids = ids.join(',');
                            }
                            if (dateRange === 'custom_date') {
                                _b = __read(ezdia.util.getUrlParams([
                                    'fromDate',
                                    'toDate',
                                    'compareFromDate',
                                    'compareToDate'
                                ]), 4), fromDate = _b[0], toDate = _b[1], compareFromDate = _b[2], compareToDate = _b[3];
                                data.fromDate = fromDate;
                                data.toDate = toDate;
                                data.compareFromDate = compareFromDate;
                                data.compareToDate = compareToDate;
                            }
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.ajaxExportDate(actionUrl, data)];
                        case 2:
                            response = _c.sent();
                            // eslint-disable-next-line no-alert
                            ezdia.alert('Export', response.msg);
                            return [3 /*break*/, 4];
                        case 3:
                            ex_1 = _c.sent();
                            if (ex_1.success === false) {
                                ezdia.util.showSuccessError({
                                    message: ex_1.msg ||
                                        'An error occurred while processing your request. Please try again.',
                                    error: true,
                                    autohide: true
                                });
                            }
                            else {
                                // eslint-disable-next-line no-console
                                console.error(ex_1);
                            }
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        EzAnalytics.prototype.init = function () {
            var pageParams = $.ezdia.config.pageParams;
            var formType = pageParams.formType;
            if (formType === 'eza_alert_form') {
                this.url = 'ezaAlertsData.htm';
            }
            else {
                this.url = 'ezaListsData.htm';
            }
            this.cache = {
                editfrm: $('#ez-edit-store-form'),
                editfrmCol: $('#ez-edit-store-form-col'),
                editfrminputs: $('#ez-edit-store-form-inputs'),
                bulkEditFrm: $('#bulkEditFrm'),
                quickactionfield: $('#quickactionfield'),
                updateBtn: $('#ez-edit-store-form-update')
            };
        };
        EzAnalytics.prototype.dateFilter = function () {
            ezdia.component.pageFiltersAndHeading.dateRange();
        };
        EzAnalytics.prototype.channelFilter = function () {
            var channel = $.ezdia.config.pageParams.channel;
            var $element = $('#ez-js-channel');
            if (channel) {
                $element.val(channel);
            }
            $element.on('change', this.hanelPrimaryFilertOnChange);
            $element.chosen();
        };
        EzAnalytics.prototype.hanelPrimaryFilertOnChange = function () {
            var _a = this, name = _a.name, value = _a.value;
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set(name, value);
            window.location.search = searchParams.toString();
        };
        EzAnalytics.prototype.search = function () {
            var e_2, _a;
            this.dateFilter();
            this.channelFilter();
            var pageParams = $.ezdia.config.pageParams;
            var colModel = pageParams.colModel;
            try {
                for (var colModel_1 = __values(colModel), colModel_1_1 = colModel_1.next(); !colModel_1_1.done; colModel_1_1 = colModel_1.next()) {
                    var column = colModel_1_1.value;
                    pageParams.searchFieldsJson[column.name] = column;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (colModel_1_1 && !colModel_1_1.done && (_a = colModel_1.return)) _a.call(colModel_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            $.ezdia.initGenericSearch('#searchFrm', ezdia.pages.storeForm.export, this.url);
        };
        EzAnalytics.prototype.grid = function () {
            var rowNum = 10;
            var pageParams = $.ezdia.config.pageParams;
            var formtype = pageParams.formType, colModel = pageParams.colModel, colNames = pageParams.colNames, isGridMultiselect = pageParams.isGridMultiselect, dateRange = pageParams.dateRange, channel = pageParams.channel;
            var CFD = QUERY_PARAMS_NAMES.CFD, CTD = QUERY_PARAMS_NAMES.CTD, FD = QUERY_PARAMS_NAMES.FD, TD = QUERY_PARAMS_NAMES.TD;
            var _a = __read(ezdia.util.getUrlParams(['filterq', CFD, CTD, FD, TD]), 5), filterq = _a[0], compareFromDate = _a[1], compareToDate = _a[2], fromDate = _a[3], toDate = _a[4];
            ezdia.component.grid.create({
                id: 'grid',
                url: this.url,
                datatype: 'json',
                mtype: 'POST',
                postData: {
                    filterq: filterq,
                    fromDate: fromDate,
                    toDate: toDate,
                    compareFromDate: compareFromDate,
                    compareToDate: compareToDate,
                    dateRange: dateRange,
                    channel: channel,
                    formtype: formtype,
                    searchCondition: function () {
                        return $('#searchFrm').search('getQueryString');
                    }
                },
                colModel: colModel,
                colNames: colNames,
                rowNum: rowNum,
                multiselect: isGridMultiselect,
                beforeSelectRow: $.ezdia.desk.grid.beforeSelectRow,
                onSelectRow: this.onSelectRow,
                onSelectAll: this.onSelectRow,
                loadComplete: this.loadComplete,
                caption: 'ez analytics',
                searchFrm: '#searchFrm',
                customeBtnsWrapId: 'ez-js-grid-actions-btns',
                hidegrid: false,
                gridview: true,
                classes: 'ui-jqgrid-btable__single-row'
            });
        };
        EzAnalytics.prototype.loadComplete = function () {
            var pageParams = $.ezdia.config.pageParams;
            var $grid = $('#grid');
            var recordCount = $grid.jqGrid('getGridParam', 'records');
            var rowNum = $grid.jqGrid('getGridParam', 'rowNum');
            var gridCaption = pageParams.gridCaption || 'ez Analytics';
            if (pageParams.isGridMultiselect && recordCount > rowNum) {
                gridCaption = ezdia.templates.grid.countAndSelectCaption(recordCount);
            }
            gridCaption = ezdia.templates.grid.caption(gridCaption);
            $grid.jqGrid('setCaption', gridCaption);
            hideShowDeskForm('#bulkEditFrm');
            ezdia.component.form.hide();
            setGridCellTitle();
            ezdia.pages.ezAnalytics.editableFieldsActions();
            if (pageParams.sysSelectFirst) {
                $.ezdia.grid.selectFirstItem('#grid');
            }
        };
        EzAnalytics.prototype.onSelectRow = function (ids, clicked) {
            var self = ezdia.pages.ezAnalytics;
            var grid = $(this);
            var selIds = ezdia.util.getSelectedGridItemsByGridId();
            var deselectrow = grid.jqGrid('getGridParam', 'deselectrow');
            if ((selIds && selIds.length > 1) || deselectrow) {
                hideShowDeskForm('#bulkEditFrm');
                ezdia.component.form.show();
                if (deselectrow) {
                    grid.jqGrid('resetSelection');
                    grid.jqGrid('setGridParam', { deselectrow: false });
                }
            }
            else if (ids && clicked) {
                ezdia.component.form.show();
                ezdia.pages.storeForm.resetSelectedRow.call(self);
                ezdia.pages.storeForm.form.call(self, ids);
            }
            else if (!selIds.length) {
                ezdia.component.form.hide();
                hideShowDeskForm('');
            }
        };
        EzAnalytics.prototype.handelOnClickOnAlertSettings = function () {
            return __awaiter(this, void 0, void 0, function () {
                var actiontype, response, ex_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            actiontype = 'eza_alert_settings';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.ajaxGetAlertSettings(actiontype)];
                        case 2:
                            response = _a.sent();
                            this.showAlerts(actiontype, response);
                            return [3 /*break*/, 4];
                        case 3:
                            ex_2 = _a.sent();
                            // eslint-disable-next-line no-console
                            console.error(ex_2);
                            ezdia.util.showSuccessError({
                                message: 'Error fetching data. Please try again!',
                                error: true,
                                autohide: false
                            });
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        EzAnalytics.prototype.showAlerts = function (actiontype, response) {
            var e_3, _a;
            var self = this;
            var quickactionObj = $.ezdia.config.pageParams.quickactionObj;
            var column = null;
            try {
                for (var quickactionObj_2 = __values(quickactionObj), quickactionObj_2_1 = quickactionObj_2.next(); !quickactionObj_2_1.done; quickactionObj_2_1 = quickactionObj_2.next()) {
                    var quickaction = quickactionObj_2_1.value;
                    var name_2 = quickaction.name, quickActionFields = quickaction.quickActionFields;
                    if (name_2 === actiontype) {
                        column = $.extend(true, {}, quickActionFields.alert_setting);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (quickactionObj_2_1 && !quickactionObj_2_1.done && (_a = quickactionObj_2.return)) _a.call(quickactionObj_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
            if (!column) {
                return;
            }
            column.edittype = column.fieldType;
            column.name = column.field;
            column.id = ezdia.util.makeId();
            column.removeDisabled = true;
            var inputProps = {
                column: column,
                value: JSON.stringify(response)
            };
            var wrapperID = actiontype + "-wrapper";
            var wrapper = ezdia.util.getWrapper(wrapperID);
            var input = $.ezdia.inputs.create(inputProps, actiontype);
            var htmlContent = "<form class=\"form-horizontal ezdia-form eza-alerts-form\">\n        <div data-row=\"input\" class=\"inputs\">" + input + "</div>\n        </form>";
            wrapper.html(htmlContent).dialog({
                modal: true,
                title: 'Alert Settings',
                width: 1100,
                height: 400,
                buttons: [
                    {
                        text: 'Cancel',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Save',
                        class: 'btn-primary',
                        click: function () {
                            self.saveAlertSettings(column.id);
                        }
                    }
                ]
            });
            $.ezdia.widgets.load(actiontype);
            $.ezdia.widgets.init(inputProps, actiontype);
            $.ezdia.widgets.create(actiontype);
        };
        EzAnalytics.prototype.saveAlertSettings = function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var data, dataForm, response, ex_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            data = $("#" + id).val();
                            dataForm = $("#" + id).closest('form');
                            if (!dataForm.valid()) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, this.ajaxSaveAlertSettings(data)];
                        case 1:
                            response = _a.sent();
                            if (response.success) {
                                ezdia.util.showSuccessError({
                                    message: response.msg
                                });
                            }
                            else {
                                ezdia.util.showSuccessError({
                                    message: response.msg,
                                    error: true,
                                    autohide: false
                                });
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            ex_3 = _a.sent();
                            // eslint-disable-next-line no-console
                            console.error(ex_3);
                            ezdia.util.showSuccessError({
                                message: 'Error updating data. Please try again.',
                                error: true,
                                autohide: false
                            });
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        EzAnalytics.prototype.quickAction = function () {
            var listItems = '';
            var arr = [];
            var quickactionObj = $.ezdia.config.pageParams.quickactionObj;
            listItems = $.ezdia.quickLinks.create(quickactionObj, arr, true);
            if (listItems) {
                $('#qactiondiv').html(listItems);
                $.ezdia.quickLinks.triggersActive('#ez-quick-action-links');
            }
            $.ezdia.showMorelinks();
        };
        EzAnalytics.prototype.actions = function () {
            var formType = $.ezdia.config.pageParams.formType;
            this.cache.updateBtn.on('click', this.update.bind(this));
            $('#ez-edit-store-form-cancel').on('click', this.cancel.bind(this));
            ezdia.component.form.closeFormBtn('ez-js-form-right-close');
            if (formType === 'eza_alert_form') {
                $('#ez_js_alert_settings').on('click', this.handelOnClickOnAlertSettings.bind(this));
            }
        };
        EzAnalytics.prototype.editableFieldsActions = function () {
            var e_4, _a;
            var gridEditableFields = ezdia.config.GRID_EDITABLE_FIELDS.gridContainer;
            if (gridEditableFields.list) {
                var _loop_1 = function (colModel) {
                    $("#" + colModel.hiddenId).on('change', function change(event) {
                        updateList(colModel, event);
                    });
                };
                try {
                    for (var _b = __values(gridEditableFields.list), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var colModel = _c.value;
                        _loop_1(colModel);
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        };
        EzAnalytics.prototype.update = function () {
            var self = ezdia.pages.ezAnalytics;
            var formType = $.ezdia.config.pageParams.formType;
            var _a = this.cache, editfrm = _a.editfrm, btn = _a.updateBtn;
            btn.button('loading');
            if (!editfrm.valid()) {
                btn.button('reset');
                return false;
            }
            var data = editfrm.serialize();
            var selIds = ezdia.util.getSelectedGridItemsByGridId();
            data += "&ids=" + selIds + "&formtype=" + formType;
            $.ajax({
                type: 'POST',
                url: editfrm[0].action,
                data: data,
                dataType: 'text',
                success: function (res) {
                    btn.button('reset');
                    var response = ezdia.util.jsonParse(res) || {};
                    if (response.success) {
                        ezdia.util.showSuccessError({
                            message: response.msg || 'Data updated successfully'
                        });
                        ezdia.component.form.hide();
                        $('#grid').trigger('reloadGrid');
                        self.cache.editfrm.hide().localStorage('discard');
                        hideShowDeskForm();
                    }
                    else {
                        ezdia.util.showSuccessError({
                            message: response.msg || 'Error updating data',
                            error: true
                        });
                    }
                },
                error: function (response) {
                    btn.button('reset');
                    ezdia.util.showSuccessError({
                        message: response.msg || 'Error updating data',
                        error: true
                    });
                }
            });
            return false;
        };
        EzAnalytics.prototype.cancel = function () {
            var _a = this.cache, editfrm = _a.editfrm, editfrminputs = _a.editfrminputs;
            editfrm.hide();
            editfrminputs.empty();
            $('#message').html('');
            ezdia.component.form.hide();
        };
        /**
         *
         * @param actiontype
         */
        EzAnalytics.prototype.ajaxGetAlertSettings = function (quickActionName) {
            var formtype = $.ezdia.config.pageParams.formType;
            return new Promise(function (resolve, reject) {
                $.ajax({
                    type: 'POST',
                    url: 'ezaAlertSettings.htm',
                    data: {
                        formtype: formtype,
                        quickActionName: quickActionName
                    },
                    dataType: 'json',
                    success: function (response) {
                        resolve(response);
                    },
                    error: function (response) {
                        reject(response);
                    }
                });
            });
        };
        EzAnalytics.prototype.ajaxSaveAlertSettings = function (settingsData) {
            return new Promise(function (resolve, reject) {
                $.ajax({
                    url: 'saveAlertSettings.htm',
                    data: {
                        settingsData: settingsData
                    },
                    type: 'POST',
                    dataType: 'json',
                    success: function (response) {
                        if (!$.isEmptyObject(response)) {
                            resolve(response);
                        }
                        else {
                            reject(response);
                        }
                    },
                    error: function (response) {
                        reject(response);
                    }
                });
            });
        };
        /**
         *
         * @param actiontype
         */
        EzAnalytics.prototype.ajaxExportDate = function (url, data) {
            return new Promise(function (resolve, reject) {
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: data,
                    dataType: 'json',
                    success: function (response) {
                        if (response.success) {
                            resolve(response);
                        }
                        else {
                            reject(response);
                        }
                    },
                    error: function (response) {
                        reject(response);
                    }
                });
            });
        };
        return EzAnalytics;
    }());
    var pages;
    (function (pages) {
        pages.ezAnalytics = new EzAnalytics();
    })(pages = ezdia.pages || (ezdia.pages = {}));
})(ezdia || (ezdia = {}));
